import { render, staticRenderFns } from "./OrderTaskNew.vue?vue&type=template&id=38954e45&scoped=true&"
import script from "./OrderTaskNew.vue?vue&type=script&lang=js&"
export * from "./OrderTaskNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38954e45",
  null
  
)

export default component.exports